<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 41 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M22.0022 29C22.5601 32.9463 26.3768 36 31.0021 36C35.6275 36 39.4442 32.9463 40.0021 29H22.0022Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M0.00219727 29C0.560121 32.9463 4.37682 36 9.00215 36C13.6275 36 17.4442 32.9463 18.0021 29H0.00219727Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M9.47394 4.99539L1.99938 29.0017L0 29L9.47394 4.99539Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M9.47394 4.99539L16.0088 28.9979L18.0082 28.9962L9.47394 4.99539Z" :fill="fill" fill-rule="evenodd"/>
    <path d="M18.0022 5H9L20.0022 9L32 5H22.0022V7H18.0022V5Z" :fill="fill"/>
    <path clip-rule="evenodd" d="M31.4761 4.99539L24.0016 29.0017L22.0022 29L31.4761 4.99539Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M31.4761 4.99539L38.011 28.9979L40.0104 28.9962L31.4761 4.99539Z" :fill="fill" fill-rule="evenodd"/>
    <circle cx="20.0022" cy="5" r="2" :stroke="fill" stroke-width="2"/>
    <path d="M20 34L27 38H13L20 34Z" :fill="fill"/>
    <path d="M20 34L27 38H13L20 34Z" :fill="fill"/>
    <path d="M18.0022 36L20.0022 8L22.0022 36H18.0022Z" :fill="fill"/>
  </svg>

</template>

<script>
export default {
  name: 'Scales',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
